// sentry-event-emitter.ts
type Callback = (_eventId: string, _unique: string) => void;

let callbacks: Callback[] = [];

/**
 * Register a callback for Sentry events.
 * Returns a clean unsubscribe function.
 */
export const onSentryEvent = (callback: Callback): (() => void) => {
  callbacks.push(callback);

  return () => {
    // Filter out this callback safely
    callbacks = callbacks.filter((cb) => cb !== callback);
  };
};

/**
 * Trigger all registered callbacks with eventId and unique tag
 */
export const triggerSentryEvent = (eventId: string, unique: string) => {
  // make a copy to prevent issues if callbacks unsubscribe themselves
  [...callbacks].forEach((cb) => cb(eventId, unique));
};
